import { render } from "./TrialBalance.vue?vue&type=template&id=5f56d7d6&ts=true"
import script from "./TrialBalance.vue?vue&type=script&lang=ts"
export * from "./TrialBalance.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__